import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ConversationView } from '@/features/messages/conversation-view';
import { useT } from '@/i18n/react';

const searchSchema = z.object({ project: z.string().catch('') });

export const Route = createFileRoute('/_app/messages/$conversationId')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const t = useT();
  const { conversationId } = Route.useParams();
  const { project } = Route.useSearch();
  if (!project) return <p className="row-detail">{t('This conversation is not available')}</p>;
  return (
    <ConversationView
      key={conversationId}
      scope={{ kind: 'project', projectId: project }}
      conversationId={conversationId}
      back={{ to: '/messages', label: 'All messages' }}
    />
  );
}
